module.exports = __webpack_public_path__ + "img/1740575012067.af2375f3.png";